import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, History } from "lucide-react";
import { formatShortDate } from "@/lib/api";

const SHOWN = 5;

// Past LGTDZ concerts held in one place (newest first), folded after 5
export const PlaceHistory = ({ placeId, events }) => {
  const [open, setOpen] = useState(false);
  if (!events?.length) return null;
  const shown = open ? events : events.slice(0, SHOWN);
  return (
    <div className="mt-5" data-testid={`place-history-${placeId}`}>
      <p className="flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] font-bold text-zinc-300">
        <History className="w-3.5 h-3.5" /> Déjà passé ici · {events.length} concert{events.length > 1 ? "s" : ""}
      </p>
      <ul className="mt-2 space-y-1.5">
        {shown.map((e) => (
          <li key={e.slug}>
            <Link to={`/agenda/${e.slug}`} className="flex items-baseline gap-3 text-zinc-200 hover:text-primary transition-colors" data-testid={`place-history-item-${e.slug}`}>
              <span className="text-xs text-zinc-400 shrink-0 w-28">{formatShortDate(e.date)}</span>
              <span className="text-sm truncate">{e.title}</span>
            </Link>
          </li>
        ))}
      </ul>
      {events.length > SHOWN && (
        <button type="button" onClick={() => setOpen((v) => !v)} data-testid={`place-history-toggle-${placeId}`}
          className="mt-2 inline-flex items-center gap-1 text-[11px] uppercase tracking-[0.2em] font-bold text-primary hover:text-white transition-colors">
          {open ? "Voir moins" : `Voir les ${events.length - SHOWN} autres`} <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
        </button>
      )}
    </div>
  );
};
